import api from "../../services/api";

export async function postLogAPI(body) {
  let retorno = await api.post(`/log`, body).catch((e) => {
    return e;
  });

  if (retorno.status == 200) {
    return true;
  } else {
    return false;
  }
}
